import { render, staticRenderFns } from "./AudioEditorComponent.vue?vue&type=template&id=1904f8a8&"
import script from "./AudioEditorComponent.vue?vue&type=script&lang=js&"
export * from "./AudioEditorComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports